import { Component, OnInit, HostListener, Output, EventEmitter, SimpleChanges, ViewChild, TemplateRef, ElementRef, AfterViewChecked, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { State, WebsiteStateStore } from './website.state.store';
import { PartyMember, ScheduleItem, TravelInfo, Website, Question, RegistryItem, WeddingEvent, TravelLink } from './wedding';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { DatepickerOptions } from 'ng2-datepicker';
import * as en from 'date-fns/locale/en';
import { RegistryService } from '../registry/registry.service';
import { filter } from 'rxjs/operators';
import { Inject } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';
import { RegistryStateStore } from '../registry/registry.state.store';
import { Registry } from '../registry/registry';
import { Gift } from '../gift/gift';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { default as defaultWebsiteCeline } from '../website-template-celine/default-data';
import { default as defaultWebsiteLottie } from '../website-template-lottie/default-data';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Contribution } from '../track/contribution';
import { from } from 'rxjs/observable/from';
import { Subscription } from 'rxjs/Subscription';
import { WebsiteComponent } from '../website/website.component';
import { AnalyticsService } from '../analytics/analytics.service';
@Component({
  selector: 'app-website-builder',
  templateUrl: './website-builder.component.html',
  styleUrls: ['./website-builder.component.scss']
})
export class WebsiteBuilderComponent implements OnInit, AfterViewChecked, AfterViewInit {
  viewingSecondLanguage: boolean;
  secondLanguageCode: string;
  contributions: any;
  paidContributions: Contribution[];
  totalContributionAmount: number;
  hideMobileMenu: boolean;
  currentPosition: number;
  showMiniLaunch: boolean = false;
  slide: number;
  private subscription: Subscription;

  urlInvalid: boolean[] = [];
  currentEditingQuestionIndex: number;
  fromBuilder: boolean;
  disableSaveTravelGuideButton = false;
  endDateError: boolean;
  touchstartY = 0;
  touchendY = 0;
  isSwipedDown = false;
  isTouching: boolean;

  questions = [
    { text: 'When should I RSVP by?', answer: 'Please respond by the date on your invitation or the deadline listed on our wedding website. We can\'t wait to celebrate with you!' },
    { text: 'Can I bring a plus-one?', answer: 'Due to limited venue capacity, we can only accommodate those guests formally addressed on the invitation or RSVP.' },
    { text: 'Are children welcome at the wedding?', answer: 'Due to limited venue space, we are unable to accommodate children. We truly appreciate your understanding.' },
    { text: 'What kind of weather should I expect?', answer: 'We expect beautiful weather, but recommend checking the forecast closer to the big day.' },
    { text: 'What are the parking options?', answer: 'Parking details will be provided with the invitation or on our wedding website. We\'ll make sure it\'s easy for you!' },
    { text: 'Is there a dress code?', answer: 'Dress comfortably and stylishly—we want you to feel your best. Check the invitation or our wedding website for the dress code.' },
    { text: 'Is it okay to take pictures?', answer: 'We kindly request an unplugged ceremony. We invite you to be truly present with us—please turn off all devices until after the ceremony.' },
    { text: 'Who to contact for questions?', answer: 'Feel free to reach out to us with any questions. You can find our contact info on the invitation.' },
    { text: 'What time should I arrive?', answer: 'Please arrange to arrive 30 minutes before the ceremony starts to ensure you\'re seated and settled.' },
    { 
      text: 'Will transportation be provided?', 
      answer: 'Yes! A shuttle service will run between the venue and designated pickup locations. Check the Schedule section on our wedding website for full details.' 
    }
  ];
  showGuide: boolean;
  currentScheduleItemIndex: number;
  showEventEndDate: boolean;
  ngAfterViewChecked() {
    let element = document.getElementById('section-detail');
    if (element) {
      element.scrollTop = 0;
    }
    let exists = document.getElementsByClassName('modal-hide-scroll');
    if (exists && exists.length > 0) {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';

    }
  }
  @Output() websiteChange = new EventEmitter<Website>();
  @ViewChild('templateWelcome', { read: true }) templateWelcome: TemplateRef<any>;
  @ViewChild('templateAnnouncement', { read: true }) templateAnnouncement: TemplateRef<any>;
  // @ViewChild('dropzone', {  }) dropzone: TemplateRef<any>;
  @Output() filesDropped = new EventEmitter<FileList>();
  @ViewChild('appWebsite') appWebsite: WebsiteComponent;
  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;
  @ViewChild('content') content: ElementRef;
  @ViewChild('design') design: ElementRef;
  times: string[] = [];
  scale = 1;
  gifts: Gift[];
  setupMode = false;
  showResetColour = false;
  defaultTemplatecolours: {
    light: string;
    dark: string;
    lightAccent: string;
    darkAccent: string;
    accent: string;
  }

  currentLanguage = 'English';
  otherLanguage = '';
  containerStyle: string = 'desktop';
  websiteContainerWidth: any = 'auto';
  showShareModal = false;
  websiteContainerHeight: any = 'auto';
  mode: 'design' | 'content' = 'design';
  editingSecondaryLanguage = false;
  showTemplateSelectionModal = false;
  currentTemplateFonts: string[]
  enableSave = false
  editingSection = false;
  currentSectionInEditMode: string;
  currentScheduleEventEdditing: ScheduleItem;
  showFontSelectionModal = false;
  currentTravelInfoEdditing: TravelInfo;
  currentPartyMemberEdditing: PartyMember;
  state: State;
  website: Website;
  isSaved = false;
  showEditColourPalette = false;
  placeholderName = 'Name';
  showSettings = false;
  groupedScheduleItems: any = [];
  showFontUploadModal = false
  currentFont: string;
  light_isLight = false;
  dark_isLight = false;
  lightAccent_isLight = false;
  darkAccent_isLight = false;
  accent_isLight = false;
  previewTemplate: string;
  previous_light: string;
  previous_dark: string;
  previous_lightAccent: string;
  previous_darkAccent: string;
  previous_accent: string;
  customFonts: any = [];
  previousVisibilitySettingState: boolean
  previousSectionNameState: string;






  colorVibes = [
    { light: '#f4f3e8', lightAccent: '#e6dcc8', accent: '#ebfc72', darkAccent: '#aec0ab', dark: '#212e21' },
    { light: '#FFF6ED', lightAccent: '#EFF483', accent: '#e8e1fd', darkAccent: '#ED6B2E', dark: '#184027' },
    { light: '#fff', lightAccent: '#FFF5D9', accent: '#FBE19F', darkAccent: '#FFCF5A', dark: '#655A3F' },
    { light: '#EAE6E0', lightAccent: '#C4C4C4', accent: '#A5CA9A', darkAccent: '#A794F8', dark: '#2C2C2C' },
    { light: '#D8CFC9', lightAccent: '#92939C', accent: '#E36B36', darkAccent: '#907E73', dark: '#2F2D2D' },
    { light: '#fff', lightAccent: '#E5E9FD', accent: '#F598FF', darkAccent: '#94ABF9', dark: '#171D3A' },
    { light: '#FEFFE9', lightAccent: '#FFFDC1', accent: '#DEE777', darkAccent: '#B8BC7F', dark: '#2F3105' },
    { light: '#fff', lightAccent: '#E0E2ED', accent: '#EEB072', darkAccent: '#476C77', dark: '#303D40' },
    { light: '#EAE6E0', lightAccent: '#E5E0DA', accent: '#C1BFCB', darkAccent: '#7D7B46', dark: '#583B20' },
    { light: '#F7F6F3', lightAccent: '#FFE974', accent: '#E65938', darkAccent: '#BD005B', dark: '#000000' },
    { light: '#EAE6DD', lightAccent: '#EED286', accent: '#7CB5B2', darkAccent: '#34659B', dark: '#2D2D2A' },
    { light: '#fff', lightAccent: '#FFCF5A', accent: '#F2B8B4', darkAccent: '#B564F7', dark: '#000000' },
    { light: '#fff', lightAccent: '#B3C2CF', accent: '#EAEC78', darkAccent: '#8C4E2F', dark: '#000000' },
    { light: '#fff', lightAccent: '#E0E2ED', accent: '#9CE5C7', darkAccent: '#5E65C4', dark: '#484955' },
    { light: '#FEFAF6', lightAccent: '#F8EDE0', accent: '#E9A843', darkAccent: '#D394AB', dark: '#294F3F' },
    { light: '#F5F5F5', lightAccent: '#EAE6E0', accent: '#A74D4A', darkAccent: '#818B7E', dark: '#121212' },
    { light: '#FAFAFA', lightAccent: '#fff', accent: '#DCDCDC', darkAccent: '#1C1C1C', dark: '#000000' },
    { light: '#fff', lightAccent: '#DBD9D0', accent: '#D4967D', darkAccent: '#495958', dark: '#3F4A49' },
    { light: '#fff', lightAccent: '#DFE0E1', accent: '#A8A6A0', darkAccent: '#38383B', dark: '#000000' },
    { light: '#fff', lightAccent: '#D4D2CC', accent: '#9C8B7E', darkAccent: '#352D28', dark: '#000000' },
    { light: '#fff', lightAccent: '#E6E4E8', accent: '#C79288', darkAccent: '#625447', dark: '#000000' },
    { light: '#fff', lightAccent: '#EEEDEB', accent: '#E0CCBE', darkAccent: '#747264', dark: '#000000' },
    { light: '#fff', lightAccent: '#F1F1EF', accent: '#C8A47E', darkAccent: '#32273B', dark: '#000000' },
    { light: '#fff', lightAccent: '#EFEFEE', accent: '#A3826C', darkAccent: '#3E3D3D', dark: '#000000' },
    { light: '#fff', lightAccent: '#E0E0DB', accent: '#243551', darkAccent: '#2A2829', dark: '#000000' },
    { light: '#fff', lightAccent: '#EAEAEE', accent: '#1470AF', darkAccent: '#8EB6DB', dark: '#000000' },
    { light: '#fff', lightAccent: '#EACEB0', accent: '#F58847', darkAccent: '#282D30', dark: '#000000' },
    { light: '#fff', lightAccent: '#FDF0E6', accent: '#F08E80', darkAccent: '#0B0D63', dark: '#000000' },
    { light: '#fff', lightAccent: '#E7D1B5', accent: '#F1A638', darkAccent: '#344734', dark: '#000000' },
    { light: '#fff', lightAccent: '#F8DFDB', accent: '#FC221C', darkAccent: '#40140F', dark: '#000000' },
    { light: '#fff', lightAccent: '#DAD9D9', accent: '#FF5E1A', darkAccent: '#282828', dark: '#000000' },
    { light: '#fff', lightAccent: '#E1DFD9', accent: '#209D50', darkAccent: '#1D231C', dark: '#000000' },
    { light: '#fff', lightAccent: '#F4F4F3', accent: '#FFC700', darkAccent: '#383838', dark: '#000000' },
    { light: '#fff', lightAccent: '#DEDCD6', accent: '#0303AB', darkAccent: '#FF661F', dark: '#000000' },
    { light: '#fff', lightAccent: '#F4F4F3', accent: '#7877E6', darkAccent: '#4F4F4F', dark: '#000000' },
    { light: '#fff', lightAccent: '#fff', accent: '#8DD9BF', darkAccent: '#28211E', dark: '#000000' },
  ];

  colorVibesMinimal = [
    { light: "#F9F6F0", dark: "#2C3E50" },  // Bone White & Midnight Navy
  { light: "#FFE2E2", dark: "#FF4D6D" },  // Cotton Candy & Vibrant Rose
  { light: "#EFF8F6", dark: "#2B6B5B" },  // Sea Foam & Emerald
  { light: "#FCE8D5", dark: "#2D3047" },  // Warm Peach & Ink Blue
  { light: "#F4EFF8", dark: "#574B90" },  // Whisper Purple & Deep Violet
  { light: "#E7F9F9", dark: "#1B998B" },  // Aqua Mist & Modern Teal
  { light: "#FFF5EC", dark: "#9C6144" },  // Champagne & Terra Cotta
  { light: "#F0E5D8", dark: "#5E4B56" },  // Vanilla Cloud & Mauve Shadow
  { light: "#FFE8E8", dark: "#D62839" },  // Blush Light & Cherry Red
  { light: "#F0F4F2", dark: "#3A5A40" },  // Frost & Forest
  { light: "#FFEFD1", dark: "#2E294E" },  // Golden Hour & Deep Space
  { light: "#EDF4F7", dark: "#34495E" },  // Cloud & Storm Blue
  { light: "#FFE9F3", dark: "#C04ABC" },  // Sweet Pink & Electric Purple
  { light: "#F4F7F3", dark: "#5C7358" },  // Morning Mist & Sage
  { light: "#FCE1D0", dark: "#4C3B4D" },  // Sunset Peach & Aubergine
  { light: "#E8ECFF", dark: "#7209B7" },  // Ice Blue & Royal Violet
  { light: "#F9F5EA", dark: "#8B7355" },  // Cream & Warm Bronze
  { light: "#DBFFF3", dark: "#0B525B" },  // Neo Mint & Deep Teal
  { light: "#FFD6D6", dark: "#B91372" },  // Ballet Pink & Magenta
  { light: "#EFF4EF", dark: "#4B6455" },  // Mint Frost & Pine
  { light: "#F6E7FF", dark: "#4B0082" },  // Lilac Dream & Indigo
  { light: "#FFF0C1", dark: "#2D3142" },  // Butter & Charcoal
  { light: "#E0FBFC", dark: "#293241" },  // Arctic & Slate
  { light: "#FFE2E2", dark: "#6D597A" },  // Rose Cloud & Plum Velvet
  { light: "#E3F6F5", dark: "#2C698D" },  // Glacier & Ocean Blue
  { light: "#FFDDE2", dark: "#912F56" },  // Candy & Wine
  { light: "#F0F5F7", dark: "#445D6E" },  // Winter Sky & Oxford Blue
  { light: "#FFF1E0", dark: "#5C4D3C" },  // Honey Light & Rich Mocha
  { light: "#DFEFF0", dark: "#146C78" },  // Sea Salt & Maritime
  { light: "#FFE5EC", dark: "#A4133C" },  // Pink Marshmallow & Ruby Wine
  { light: "#E7FAE7", dark: "#397367" },  // Neo Green & Eucalyptus
  { light: "#F3E1FF", dark: "#4C2882" },  // Lavender Mist & Royal Purple
  { light: "#FFF3DD", dark: "#6F4518" },  // Golden Light & Dark Toffee
  { light: "#E5F4FF", dark: "#184E77" },  // Crystal & Deep Ocean
  { light: "#FFE8F0", dark: "#9E2A2B" },  // Sugar Pink & Classic Red
  { light: "#E8F3E8", dark: "#3D5A52" },  // Neo Sage & Forest Deep
  { light: "#F1E0FF", dark: "#5A189A" },  // Orchid Light & Royal Purple
  { light: "#FFF2CC", dark: "#774936" },  // Buttermilk & Rich Cedar
  { light: "#DEF2F1", dark: "#2B7C85" },  // Modern Mint & Deep Aqua
  { light: "#FFE3E3", dark: "#9A1750" },  // Peach Sorbet & Berry Wine
  { light: "#E6FFE6", dark: "#2D5A27" },  // Spring Light & Evergreen
  { light: "#F2E2FF", dark: "#51087E" },  // Wisteria & Deep Purple
  { light: "#FFF1D0", dark: "#8B4513" },  // Champagne Light & Copper
  { light: "#E0F8FF", dark: "#023E8A" },  // Sky Light & Royal Blue
  { light: "#FFE2EC", dark: "#880D1E" },  // Rose Petal & Burgundy
  { light: "#E7F7E7", dark: "#2D5A3C" },  // Willow Light & Pine Forest
  { light: "#F2E0FF", dark: "#3C096C" },  // Lilac Light & Deep Violet
  { light: "#FFF0DB", dark: "#693D3D" },  // Cream Light & Mahogany
  { light: "#E2F5FF", dark: "#003566" }   // Azure Light & Navy Deep
  ];



  originalVibes = this.colorVibes;
  firstSection = 'story';
  lastSection = 'announcement';
  private saveWebsiteSubject = new Subject<void>();
  private saveWebsiteSubjectFaster = new Subject<void>();
  options: DatepickerOptions = {
    minYear: 2018,
    maxYear: 2025,
    displayFormat: 'MMMM D YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,
    barTitleIfEmpty: 'Click to select a date',
    //  placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    //  addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };
  noDate = false;
  allSections = [

    'story',
    'schedule',
    'weddingParty',
    'travel',
    'questions',
    'registry',


  ];
  editingAnnouncement: boolean;
  editingWelcome: boolean;
  editingStory: boolean;
  showAddNewScheduleEvent: boolean;
  isEditingSchedule: boolean;
  showEndTime: boolean;
  showingPartyPersonForm: boolean;
  isEditingPerson: boolean;
  showingQuestionEditForm: boolean;
  isEditingQuestion: boolean;
  currentQuestionEdditing: Question;
  isEditingTravelInfo: boolean;
  currentRegistryItemEditing: RegistryItem;
  isEditingRegistryItem: boolean;
  uploading: boolean = false;
  showFontList: boolean;
  currentFontElement: string;
  searchFont: string;
  showChangeColourPanel: boolean;
  showPreviewTemplateModal: boolean;
  settings: Settings;
  currentUploadImage: string;
  registry: Registry;
  showDropDownLayout: boolean;
  showDropDownStyle: boolean;
  isOnLuanchedUrl: boolean;
  mobileDrawerClass: string;
  constructor(
    private websiteStateStore: WebsiteStateStore,
    private registryService: RegistryService,
    private _settingsState: SettingsStateStore,
    private _registryState: RegistryStateStore,
    private _router: Router,
    private _route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private cdr: ChangeDetectorRef,
  private _analyticsService: AnalyticsService,
    @Inject(DOCUMENT) private document: Document
  ) {

    // this.onResize()


    document.title = 'Hitchd | Website Editor';
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        let hours = i === 0 ? 12 : (i > 12 ? i - 12 : i);
        let minutes = j < 10 ? '0' + j : j;
        let ampm = i < 12 ? 'AM' : 'PM';
        this.times.push(`${hours}:${minutes} ${ampm}`);
      }
    }
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      ;
      ;
      if (event.url === '/website/builder/designs') {
        this.showTemplateSelectionModal = true;
        history.replaceState({}, 'Wedding Website Builder - Hitchd', '/website/builder');


      } else if (event.url === '/website/builder/rsvp') {
        ;
        this.mode = 'content';
        this.currentSectionInEditMode = 'rsvp';
        history.replaceState({}, 'Wedding Website Builder - Hitchd', '/website/builder');
        this.editSection('rsvp');
      } else if (event.url.includes('/website/builder/content')) {
        this.mode = 'content';
        this.showTemplateSelectionModal = false;
        history.replaceState({}, 'Wedding Website Builder - Hitchd', '/website/builder');
      }
    });
    this.isOnLuanchedUrl = this._router.url.includes('launched');
  }

  @HostListener('window:resize')

  // @HostListener('window:scroll', ['$event'])

  @HostListener('document:click', ['$event'])
  clickout(event) {



    if (this.showDropDownLayout && this.dropdownMenu && !this.dropdownMenu.nativeElement.contains(event.target)) {

      this.showDropDownLayout = false;
    }
    if (this.showDropDownStyle && this.dropdownMenu && !this.dropdownMenu.nativeElement.contains(event.target)) {

      this.showDropDownStyle = false;
    }


  }


  goToWelcomeSection() {
    this.mode = 'content';

    this.currentSectionInEditMode = 'welcome';
    this.editSection('welcome');
    //this.scrollToSection('welcome-section');
  }
  goToStorySection() {
    this.mode = 'content';
    this.editSection('story');
  }
  goToScheduleSection() {
    this.mode = 'content';
    this.editSection('schedule');
  }

  // Method to handle the translationDisabled event
  handleTranslationDisabled(): void {

    this.switchBackToEnglish();
  }

  onContentScrolled(e: any) {
    if (this.isTouching) {
      // Ignore scroll events if a touch event is in progress
      return;
    }
    let scroll = e.target.scrollTop;



    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;


  }

  onTouchStart(event: TouchEvent) {
    event.stopPropagation(); // Prevent default scrolling behavior
    this.isTouching = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.touchstartY = event.changedTouches[0].screenY;
  }

  onTouchEnd(event: TouchEvent) {

    this.touchendY = event.changedTouches[0].screenY;
    this.handleGesture();
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.isTouching = false; // Se
  }

  handleGesture() {
    const swipeThreshold = 20;
    const swipeDistance = this.touchendY - this.touchstartY;
    const asideElement = document.querySelector('aside');

    if (asideElement && swipeDistance > swipeThreshold) {
      this.isSwipedDown = true;
      if (!this.mobileDrawerClass) {
        this.mobileDrawerClass = 'drawer-bottom';
      }
      if (this.mobileDrawerClass === 'drawer-top') {
        this.mobileDrawerClass = '';
      }
    } else {
      if (!this.mobileDrawerClass) {
        this.mobileDrawerClass = 'drawer-top';
      }
      if (this.mobileDrawerClass === 'drawer-bottom') {
        this.mobileDrawerClass = '';
      }
      this.isSwipedDown = false;
    }
  }
  allQuestionsAdded(): boolean {
    
    return this.questions.every(question => this.isQuestionAdded(question.text));
  }
  moveUp() {
    if (!this.mobileDrawerClass) {
      this.mobileDrawerClass = 'drawer-top';
    }
    if (this.mobileDrawerClass === 'drawer-bottom') {
      this.mobileDrawerClass = '';
    }
    this.isSwipedDown = false;
  }

  moveDown() {
    if (!this.mobileDrawerClass) {
      this.mobileDrawerClass = 'drawer-bottom';
    }
    if (this.mobileDrawerClass === 'drawer-top') {
      this.mobileDrawerClass = '';
    }
  }
  addTravelLink() {
    if (!this.currentTravelInfoEdditing.travelLinks) {
      this.currentTravelInfoEdditing.travelLinks = [];
    }
    this.currentTravelInfoEdditing.travelLinks.push({ description: '', url: '', descriptionTranslation: '' });
    this.urlInvalid.push(false);
  }

  unInitEndTime() {
    this.showEndTime = !this.showEndTime;
    this.currentScheduleEventEdditing.endDate = null;
    this.currentScheduleEventEdditing.endTime = null;
  }

  removeTravelLink(index: number) {
    this.currentTravelInfoEdditing.travelLinks.splice(index, 1);
    this.urlInvalid.splice(index, 1);
  }
  updatedUrl(url, i) {
    this.currentTravelInfoEdditing.travelLinks[i].url = url;
    this.validateUrl(this.currentTravelInfoEdditing.travelLinks[i], i);
  }
  setStoryImageGrid(gridName: string) {
    this.website.story.imageGrid = gridName;
    this.setUpdatedOnceTouched('story.imageUrl');
    this.goToSection('story.imageUrl');
    this.saveWebsite();
  }
  validateUrl(link: TravelLink, index: number) {

    if (!link || !link.url) {

      this.urlInvalid[index] = false
      this.disableSaveTravelGuideButton = this.urlInvalid.some(invalid => invalid);
      return

    }

    const urlPattern = /^(https:\/\/|http:\/\/|www\.)/;
    this.urlInvalid[index] = false;
    if (link.url) {
      this.urlInvalid[index] = !urlPattern.test(link.url);
    }
    this.disableSaveTravelGuideButton = this.urlInvalid.some(invalid => invalid);
  }




  logger(scroll) {
    console.log({
      currentPosition: this.currentPosition,
      scroll: scroll,
      hideMobileMenu: this.hideMobileMenu,
      loggic: (document.documentElement.scrollHeight - 400) < (scroll + window.innerHeight)

    })
  }
  ngAfterViewInit() {
    this.content.nativeElement.addEventListener('scroll', this.onContentScrolled.bind(this));

   this.updateWebsiteModal();

  }


  toggleGuide() {
    this.showGuide = !this.showGuide;
    if (this.showGuide == false) {
      localStorage.setItem("seenSetupGuideWebsite", "true");
    }
  }


  toggleWebsite() {
    this.settings.weddingWebsiteEnabled = !this.settings.weddingWebsiteEnabled;
    this.saveSettings()
  }
  toggleRegistry() {
    this.settings.registryEnabled = !this.settings.registryEnabled;
    this.saveSettings()
  }

  disconnectRegistry() {
    // this.settings.registryEnabled = false;
    this.website.registry.isLinkedtoHitchd = false;
    this.websiteStateStore.updateWebsite(this.website);
    if (this.cdr) {
      this.cdr.detectChanges();
    }
  }

  setFontSet(heading: string, paragraph: string, misc: string) {
    this.website.fonts = {
      heading: heading,
      paragraph: paragraph,
      misc: misc
    }
    this.searchFont = "";

    this._analyticsService.trackEvent('Website Font Set Applied', {heading: heading, paragraph: paragraph, misc: misc});
    this.saveWebsite();
    this.showFontList = false;
  }

  setFont(fontName: string, element: string) {
    ;
    if (this.website.fonts === undefined) {
      this.website.fonts = {
        heading: '',
        paragraph: '',
        misc: ''
      };
    }

    if (element == 'Headings') {
      this.website.fonts.heading = fontName;
    } else if (element === "Paragraph") {
      this.website.fonts.paragraph = fontName;
    }
    else if (element === "Miscellaneous") {
      this.website.fonts.misc = fontName;
    }
    this.searchFont = "";
    this.searchFonts(null)
    this.saveWebsite();
    this.showFontList = false;
    this._analyticsService.trackEvent('Website Font Applied', {font: fontName, element: element});
  }

  goToSlide(index: number) {
    this._analyticsService.trackEvent('Website Onboarding Slide Next Clicked', {slide: index});
    this.slide = index;
  }

  refreshWebsiteModel() {
    
    
    this.website = this.websiteStateStore.getWebsite();
    
    // Check for essential website properties, not just any keys
    const hasEssentialProps = this.website && 
      Object.keys(this.website).length > 1 && // More than just tags
      this.website.hasOwnProperty('welcome') // Or any other essential property
      &&  this.website.hasOwnProperty('story')
      &&  this.website.hasOwnProperty('registry'); 
    if (hasEssentialProps) {
     
      this.updateWebsiteModal();
     
    } else {    

        this.website = defaultWebsiteCeline;
        this.updateWebsiteModal();
      
    }
  }

  updateWebsiteModal() {
    
    if (this.website && 
        Object.keys(this.website).length > 0 && 
        this.appWebsite) {
      this.appWebsite.updateWebsiteModal(this.website);
      if (this.cdr) {
        this.cdr.detectChanges();
      }
    }
  }

  ngOnInit() {
    
    this.websiteStateStore.googleFonts.forEach(font => {
      const styleId = `font-style-${font.name}`;
      const oldStyle = this.document.getElementById(styleId);

      if (!oldStyle) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          @font-face {
            font-family: '${font.name}';
            src: url('${font.file}')${font.file.endsWith('.woff2') ? " format('woff2')" : ''};
            font-display: swap;
          }
        `;
        this.document.head.appendChild(style);
      }
    });

    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.refreshWebsiteModel();
    });

    this.showGuide = true;
    let seenGuide = localStorage.getItem("seenSetupGuideWebsite")
    if (seenGuide) {
      this.showGuide = false;
    }

    this.saveWebsiteSubjectFaster.pipe(
      debounceTime(1000)
    ).subscribe(() => {
      this.saveWebsite()

      this.isSaved = true;
      setTimeout(() => {
        this.isSaved = false;
      }
        , 1000);
    }
    );

    this.saveWebsiteSubject.pipe(
      debounceTime(2500)
    ).subscribe(() => {
      this.saveWebsite()

      this.isSaved = true;

      setTimeout(() => {

        this.isSaved = false;
      }, 2000);
    });

    this.settings = this._route.snapshot.data.settings;
    this.website = this._route.snapshot.data.website;
    
    this.initScheduleList();
    this.checkRsvpIsEnabledOnAnyWeddingEvents(this.website);
    this.registry = this._route.snapshot.data.registry;
    this.contributions = this._route.snapshot.data.contributions;

    if (this.contributions && this.contributions.length > 0) {
      this.paidContributions = this._registryFirebaseService.getContributionsbyStatus(this.contributions, 'paid');

      if (this.paidContributions && this.paidContributions.length > 0) {
        this.totalContributionAmount = this.paidContributions.map(x => x.giftTotal).reduce((a, b) => a + b);
      }
    }
    
    if ((!this.website || Object.keys(this.website).length === 0)&& this.settings) {     
      this.website = defaultWebsiteCeline;
      this.websiteStateStore.updateWebsiteWithSetupData(this.website, this.registry);
      this.initScheduleList();
    }

    this._settingsState.getState().subscribe(state => {
      if (state && state.settings) {
        ;
        this.settings = state.settings;

        if ((!this.website || Object.keys(this.website).length === 0)&& this.settings && this.settings.weddingWebsiteEnabled) {
          this.settings.weddingWebsiteEnabled = false;
          this.website = defaultWebsiteCeline;
        }

        this.secondLanguageCode = null;
        if (this.editingSecondaryLanguage && !this.settings.enableTranslations) {
          this.editingSecondaryLanguage = false;
        }



        if (this.settings && this.settings.secondLanguage) {
          this.secondLanguageCode = this.websiteStateStore.getLanguageCode(this.settings.secondLanguage);
        }

        if (state.settings && !state.settings.enableTranslations) {
          this.switchBackToEnglish();

        }
      }


    });

    this._registryState.getState().subscribe(state => {
      this.registry = state.registry;
      this.gifts = state.gifts;
    });


    this.websiteStateStore.getState().subscribe(state => {
      this.state = state;

      if (this.state.website && Object.keys(this.state.website).length > 0) {
        // The website object is not null, not undefined, and not empty

        this.website = this.state.website;
        console.log("state WEBSITE",this.website)
        this.initScheduleList();
        this.setVibes();
        this.checkRsvpIsEnabledOnAnyWeddingEvents(this.website);
   this.updateWebsiteModal()

        this.cdr.detectChanges();

        let defaultTemplate = this.getDefaultWebsiteTemplate(this.website.template)

          ;
        if (this.website && this.website.style === 'minimal') {
          this.defaultTemplatecolours =

          {
            light: defaultTemplate.colorsMinimalTemplateDefault.light,
            dark: defaultTemplate.colorsMinimalTemplateDefault.dark,
            lightAccent: defaultTemplate.colorsMinimalTemplateDefault.light,
            darkAccent: defaultTemplate.colorsMinimalTemplateDefault.dark,
            accent: defaultTemplate.colorsMinimalTemplateDefault.dark,
          }

        } else {
          this.defaultTemplatecolours = defaultTemplate.colors;
        }
        this.customFonts = this.state.customFonts;
        if (this.customFonts && this.customFonts.length > 0) {


          this.customFonts.forEach(font => {
            const styleId = `font-style-${font.fontName}`;
            const oldStyle = this.document.getElementById(styleId);

            if (!oldStyle) {
              const style = this.document.createElement('style');
              style.id = styleId;
              style.textContent = `
              @font-face {
                font-family: '${font.fontName}';
                src: url('${font.fontUrl}') 
              }
            `;
              this.document.head.appendChild(style);
            }
          });
        }
   

        this.groupedScheduleItems = state.groupedScheduleItems;
        this.initScheduleList();
        this.initColourTexts();
        if (this.website && !this.website.sectionOrder) {
          this.website.sectionOrder = [

            'welcome',
            'story',
            'schedule',
            'weddingParty',
            'travel',
            'questions',
            'registry',

          ];
        } else {
          //get items that don't exit in this.allSections
          let diff = this.allSections.filter(x => !this.website.sectionOrder.includes(x));
          this.website.sectionOrder = this.website.sectionOrder.concat(diff);
        }

        this.website.sectionOrder = this.website.sectionOrder.filter(x => x != 'rsvp');

      } else {
        this.settings.weddingWebsiteEnabled = false;
        this.website = defaultWebsiteCeline;
      }


    });

    ///initialize this.website here and all its nested objects
    this.subscription = this.websiteStateStore.scrolltoSource$.subscribe((scrollTo) => {

      this.mode = 'content';
      this.editSection(scrollTo);
    });


    this._route.fragment.subscribe(fragment => {

      if (fragment == 'welcome') {
        this.mode = 'content';
        this.editSection('welcome');
      }
      if (fragment == 'travel') {
        this.mode = 'content';
        this.editSection('travel');
      }

    });

    let sectionName = localStorage.getItem('sectionName');

    if (sectionName) {
      this.mode = 'content'

      this.editSection(sectionName);
      this.scrollToSection(sectionName + "-section")
    }




  }
  showScrollBar() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }
  onboardingCompleted(isSkip: boolean = false) {
    this.settings.completedWebsiteOnboarding = true;

    this._analyticsService.trackEvent('Website onboarding completed', {});
    if (isSkip) {
      this._analyticsService.trackEvent('Website onboarding skipped', {});
    }
    if (this.website && this.website.isLive == undefined) {
      this.website.isLive = false;
    }

    this.websiteStateStore.updateWebsite(this.website);

    //show scroll bar
    this.showScrollBar();
    this.saveSettings();
  }
  openFontUploader() {
    this._analyticsService.trackEvent('Website Open Font Uploader', {});
    document.getElementById('file_input_id_font').click();
  }

  openImageUploader(id: string) {
    this.currentUploadImage = id;
    this._analyticsService.trackEvent('Website Open Image Uploader', {imageId: id});
    document.getElementById('file_input_id').click();
  }


  swapElement(array, indexA, indexB) {
    // const tmp = array[indexA];
    // array[indexA] = array[indexB];
    // array[indexB] = tmp;
    array.splice(indexB, 0, array.splice(indexA, 1)[0]);




  }

  checkRsvpIsEnabledOnAnyWeddingEvents(website: Website) {
    let isRSVPEnabled = false;
    if (website && Object.keys(website).length > 0) {

      if (website && website.weddingEvents) {
        isRSVPEnabled = website.weddingEvents.some(x => x.collectRsvpsOnWebsite);
      }
      website.rsvp.isEnabled = isRSVPEnabled;
    }



  }


  saveSettings() {
    this._settingsState.updateSettings(this.settings);
  }

  handleUploadingImage(event: any) {
    this.uploading = true;
  }


  showFontListForElemt(element: string) {

    //init
    // this.currentTemplateFonts = [];
    // this.currentTemplateFonts.push(this.website.fonts.heading);
    // this.currentTemplateFonts.push(this.website.fonts.paragraph);
    // this.currentTemplateFonts.push(this.website.fonts.misc);


    this.currentTemplateFonts = Array.from(new Set([
      this.website.fonts.heading,
      this.website.fonts.paragraph,
      this.website.fonts.misc
    ]));

    if (element === 'Headings') {
      this.currentFont = this.website.fonts.heading;
    } else if (element === "Paragraph") {
      this.currentFont = this.website.fonts.paragraph;
    }
    else if (element === "Miscellaneous") {
      this.currentFont = this.website.fonts.misc;
    }




    this.showFontList = true
    this.currentFontElement = element;

  }

  removeImageWelcomeHeroUrl() {
    this._analyticsService.trackEvent('Website Remove Welcome Hero Image', {});
    this.website.welcome.heroImageUrl = '';
    this.saveWebsite();
  }
  handleImageUploaded(event: any) {
    this._analyticsService.trackEvent('Website Image Uploaded', {imageId: this.currentUploadImage});
    if (this.currentUploadImage === 'welcome') {
      this.website.welcome.heroImageUrl = event;
      this.website.welcome.heroImageUrlEnabled = true;
      this.setUpdatedOnceTouched('welcome.heroImageUrl');
      this.saveWebsite();
    }
    if (this.currentUploadImage === 'weddingParty') {
      this.currentPartyMemberEdditing.imageUrl = event;
    }

    if (this.currentUploadImage === 'story') {
      this.website.story.imageUrl = event;
      this.website.story.imageEnabled = true;
      this.goToSection('story.imageUrl');
      this.setUpdatedOnceTouched('story.imageUrl');
      this.saveWebsite();
    }
    if (this.currentUploadImage === 'story2') {
      this.website.story.imageUrl2 = event;
      this.website.story.imageEnabled = true;
      this.goToSection('story.imageUrl');
      this.setUpdatedOnceTouched('story.imageUrl');
      this.saveWebsite();
    }
    if (this.currentUploadImage === 'story3') {
      this.website.story.imageUrl3 = event;
      this.website.story.imageEnabled = true;
      this.goToSection('story.imageUrl');
      this.setUpdatedOnceTouched('story.imageUrl');
      this.saveWebsite();
    }
    if (this.currentUploadImage === 'story4') {
      this.website.story.imageUrl4 = event;
      this.website.story.imageEnabled = true;
      this.goToSection('story.imageUrl');
      this.setUpdatedOnceTouched('story.imageUrl');
      this.saveWebsite();
    }
    if (this.currentUploadImage === 'story5') {
      this.website.story.imageUrl5 = event;
      this.website.story.imageEnabled = true;
      this.goToSection('story.imageUrl');
      this.setUpdatedOnceTouched('story.imageUrl');
      this.saveWebsite();
    }
    if (this.currentUploadImage === 'story6') {
      this.website.story.imageUrl6 = event;
      this.website.story.imageEnabled = true;
      this.goToSection('story.imageUrl');
      this.setUpdatedOnceTouched('story.imageUrl');
      this.saveWebsite();
    }
  }

  deleteStoryImage(num: Number) {
    this._analyticsService.trackEvent('Website Delete Story Image', {imageNum: num});
    this.setUpdatedOnceTouched('story.imageUrl');
    switch (num) {

      case 1: {
        this.website.story.imageUrl = '';

        this.scrollToSection('story-section');
        this.saveWebsite();
        break;
      }
      case 2: {
        this.website.story.imageUrl2 = '';

        this.scrollToSection('story-section');
        this.saveWebsite();
        break;
      }
      case 3: {
        this.website.story.imageUrl3 = '';

        this.scrollToSection('story-section');
        this.saveWebsite();
        break;
      }
      case 4: {
        this.website.story.imageUrl4 = '';

        this.saveWebsite();
        this.scrollToSection('story-section');
        break;
      }
      case 5: {
        this.website.story.imageUrl5 = '';

        this.saveWebsite();
        this.scrollToSection('story-section');
        break;
      }
      case 6: {
        this.website.story.imageUrl6 = '';

        this.saveWebsite();
        this.scrollToSection('story-section');
        break;
      }

    }
  }

  removeImageWeddingParty() {
    this._analyticsService.trackEvent('Website Remove Wedding Party Image', {});
    this.currentPartyMemberEdditing.imageUrl = null;
  }
  uploadingFont(event: any) {
    this.showFontUploadModal = false;
  }
  handledUploadedFont(event: any) {
    ;
    if (event) {

      this._analyticsService.trackEvent('Website Font Uploaded', {font: event});
      // event = event + '?hex=ffffff';
      //this.website.font = 'custom';
      ;
      if (this.website.uploadedFonts === undefined) {
        this.website.uploadedFonts = this.website.uploadedFonts || [];
      }



      this.website.uploadedFonts.push(event);
      this.saveWebsite();
    }
  }


  private originalGooglefonts: any[]; // Add this line to store the original list of fonts
  private originalCustomFonts: any[]; // Add this line to store the original list of fonts
  private originalCurrentTemplateFonts: any[]; // Add this line to store the original list of fonts

  searchFonts(searchFont: string) {
    
    if (!this.originalGooglefonts) {
      this.originalGooglefonts = [...this.websiteStateStore.googleFonts]; // Store the original list of fonts before filtering
    }
    if (!this.originalCurrentTemplateFonts) {
      this.originalCurrentTemplateFonts = [...this.currentTemplateFonts]; // Store the original list of fonts before filtering
    }

    if (!this.originalCustomFonts && this.customFonts && this.customFonts.length > 0) {
      this.originalCustomFonts = [...this.customFonts]; // Store the original list of fonts before filtering
    }

    if (searchFont) {
      this.websiteStateStore.googleFonts = this.originalGooglefonts.filter(font => font.name.toLowerCase().includes(searchFont.toLowerCase()));
      this.currentTemplateFonts = this.currentTemplateFonts.filter(font => font.toLowerCase().includes(searchFont.toLowerCase()));

      if (this.customFonts && this.customFonts.length > 0) {
        this.customFonts = this.customFonts.filter(font => font.fontName.toLowerCase().includes(searchFont.toLowerCase()));
      }


    } else {
      this.websiteStateStore.googleFonts = [...this.originalGooglefonts];
      if (this.originalCustomFonts && this.originalCustomFonts.length > 0) {
        this.customFonts = [...this.originalCustomFonts];
      }
      this.currentTemplateFonts = [...this.originalCurrentTemplateFonts];

      // Restore the original list of fonts when searchFont is null or empty
    }
  }
  openVisibilityLink() {
    this._analyticsService.trackEvent('Website Open Visibility Link', {});
    return this._registryFirebaseService.showMiniLaunchPopup(true, true)
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getDefaultWebsiteTemplate(templateName: string) {
    switch (templateName) {
      case 'celine':
        return defaultWebsiteCeline;
      case 'lottie':
        return defaultWebsiteLottie;
      default:
        return defaultWebsiteCeline;
    }
  }

  onSort($event) {


    this.swapElement(this.website.sectionOrder, $event.oldIndex, $event.newIndex);
    this.saveWebsite();
  }
  onSortTravelItems($event) {

    this.swapElement(this.website.travel.travelInfo, $event.oldIndex, $event.newIndex);
    this.debounceFasterSave();
  }

  onSortList($event, list: any[]) {
    this.swapElement(list, $event.oldIndex, $event.newIndex);
    this.debounceFasterSave();
  }

  setLayout(layout: string) {
    this.website.layout = layout;
    this.showDropDownLayout = false;
    this.saveWebsite();
  }
  setStyle(style: string) {

    this._analyticsService.trackEvent('Website Set Style', {style: style});
    ;
    if (this.website.style == 'minimal' && style == 'vivid') {
      let websiteTemplate = this.getDefaultWebsiteTemplate(this.website.template);
      this.website.colors = websiteTemplate.colors;

    }

    this.website.style = style;

    if (this.website.style == 'minimal') {
      this.setToMinimalColours();

    }
    this.showDropDownStyle = false;
    this.setVibes();
    this.saveWebsite();

  }

  setToMinimalColours() {
    
    this.website.colors.darkAccent = this.website.colors.dark;
    this.website.colors.lightAccent = this.website.colors.light;
    this.website.colors.accent = this.website.colors.dark;

    this.website.colors.dark = this.website.colors.dark;
    this.website.colors.light = this.website.colors.light;

    let defaultTemplate = this.getDefaultWebsiteTemplate(this.website.template)

    this.defaultTemplatecolours =
    {
      light: defaultTemplate.colorsMinimalTemplateDefault.light,
      dark: defaultTemplate.colorsMinimalTemplateDefault.dark,
      lightAccent: defaultTemplate.colorsMinimalTemplateDefault.light,
      darkAccent: defaultTemplate.colorsMinimalTemplateDefault.dark,
      accent: defaultTemplate.colorsMinimalTemplateDefault.dark,
    }

  }

  isQuestionAdded(title: string): boolean {
    return this.website.questions.questions.some(question => question.title === title);
  }
  openColorPaletteSelector() {
    this._analyticsService.trackEvent('Website Open Color Palette Selector', {});
    this.previous_accent = this.website.colors.accent;
    this.previous_dark = this.website.colors.dark;
    this.previous_darkAccent = this.website.colors.darkAccent;
    this.previous_light = this.website.colors.light;
    this.previous_lightAccent = this.website.colors.lightAccent;
    this.showResetColour = false;
    this.showEditColourPalette = true

    this.scrollToTopOfSections()
  }

  setVibes() {
    
    if (this.website.style == 'minimal') {

      //select colour vibes where only one combo of light and dark exists as a combo of light and dark, eg if light is black and dark is white then light/dark black white should only exist once, but white/black is a diff value
      this.colorVibes = this.colorVibesMinimal.map(vibe => {
        return {
          light: vibe.light,
          dark: vibe.dark,
          lightAccent: vibe.light,
          darkAccent: vibe.dark,
          accent: vibe.dark
        }
      })



    } else {
      this.colorVibes = this.originalVibes;
    }

  }


  restorePreviousColour() {
    this._analyticsService.trackEvent('Website Restore Previous Colour', {});
    this.website.colors.accent = this.previous_accent;
    this.website.colors.dark = this.previous_dark;
    this.website.colors.darkAccent = this.previous_darkAccent;
    this.website.colors.light = this.previous_light;
    this.website.colors.lightAccent = this.previous_lightAccent;
    this.initColourTexts();
    this.showResetColour = false;
    this.saveWebsite();

  }
  onSortweddingParty($event) {

    this.swapElement(this.website.weddingParty.partyMembers, $event.oldIndex, $event.newIndex);
    this.debounceFasterSave();
  }
  checkDefaultData(website, defaultWebsite) {
    let isDefaultData = true;
    const keysToCheck = ['weddingEvents', 'questions', 'weddingParty', 'story'];

    for (let key of keysToCheck) {
      if (!this.deepEqual(website[key], defaultWebsite[key])) {
        isDefaultData = false;
        break;
      }
    }

    return isDefaultData;
  }
  applyTemplate() {
    ;
    this.showTemplateSelectionModal = false;
    this.showPreviewTemplateModal = false;

    let websiteTemplateToApply: Website;

    let isDefaultData = true;

    switch (this.previewTemplate) {

      case 'celine': {
        websiteTemplateToApply = defaultWebsiteCeline;
        break;
      }
      case 'lottie': {
        websiteTemplateToApply = defaultWebsiteLottie;
        break;
      }
    }

    if (this.website.template.toLowerCase() == 'celine') {

      isDefaultData = this.checkDefaultData(this.website, defaultWebsiteCeline)
      if (isDefaultData) {
        defaultWebsiteCeline.userId = this.website.userId;
        this.updateWelceomeSection(websiteTemplateToApply, defaultWebsiteCeline)
        defaultWebsiteCeline.welcome = this.website.welcome;
        this.website = defaultWebsiteCeline;
      } else {
        this.applyDefaultValuesFromTemplate(websiteTemplateToApply);
        this.updateWelceomeSection(websiteTemplateToApply, defaultWebsiteCeline)
      }



    }


    else if (this.website.template.toLowerCase() == 'lottie') {

      isDefaultData = this.checkDefaultData(this.website, defaultWebsiteLottie)
      if (isDefaultData) {
        defaultWebsiteLottie.userId = this.website.userId;
        this.updateWelceomeSection(websiteTemplateToApply, defaultWebsiteLottie)
        defaultWebsiteLottie.welcome = this.website.welcome;
        this.website = defaultWebsiteLottie;

      } else {
        this.applyDefaultValuesFromTemplate(websiteTemplateToApply);
        this.updateWelceomeSection(websiteTemplateToApply, defaultWebsiteCeline)
      }


    }



    this.website.template = this.previewTemplate;




    this.saveWebsite();
  }


  public updateWelceomeSection(toUpdateWithWebsite: Website, previousDefaultValuesWebsite: Website) {

    if (!this.website.welcome.heroImageUrl.includes('imgix')) {
      this.website.welcome.heroImageUrl = toUpdateWithWebsite.welcome.heroImageUrl;
    }
    if (this.website.welcome.eventDisplayName == previousDefaultValuesWebsite.welcome.eventDisplayName) {
      this.website.welcome.eventDisplayName = toUpdateWithWebsite.welcome.eventDisplayName;
    }
    if (this.website.welcome.eventLocation == previousDefaultValuesWebsite.welcome.eventLocation) {
      this.website.welcome.eventLocation = toUpdateWithWebsite.welcome.eventLocation;
    }
    if (!this.website.story.imageUrl.includes('imgix')) {
      this.website.story.imageUrl = toUpdateWithWebsite.story.imageUrl;
    }


  }


  private applyDefaultValuesFromTemplate(websiteTemplateToApply: Website) {

    this.website.template = this.previewTemplate;
    this.website.colors = websiteTemplateToApply.colors;
    this.website.fonts = websiteTemplateToApply.fonts;
    this.website.layout = websiteTemplateToApply.layout;
    this.website.style = websiteTemplateToApply.style;
    this.website.sectionOrder = websiteTemplateToApply.sectionOrder;
    if (!this.website.welcome.heroImageUrl.includes('imgix')) {
      this.website.welcome.heroImageUrl = websiteTemplateToApply.welcome.heroImageUrl
    }
  }
  swapMinColours(){
    let temp = this.website.colors.light;
    this.website.colors.light = this.website.colors.dark;
    this.website.colors.dark = temp;  
    this.saveWebsite();
  }

  showColourPanel() {
    this._analyticsService.trackEvent('Website Show Colour Panel', {});

    this.showChangeColourPanel = true;
    //add a 1 second delay
    this.scrollToTopOfSections();
  }

  showPreviewTemplate(template: string) {
    this._analyticsService.trackEvent('Website Show Preview Template', {template: template});
    this.showPreviewTemplateModal = true;
    this.showTemplateSelectionModal = false;
    this.previewTemplate = template;
  }

  addNewQuestion() {

    
    if (!this.website.questions || !this.website.questions.questions) {
      this.website.questions = {
        sectionName: 'Questions',
        questions: [],
        isEnabled: true,
        sectionNameTranslation: ''
      }
    }
    this.website.questions.questions.push(this.currentQuestionEdditing);
    this._analyticsService.trackEvent('Website Add New Question', {question: this.currentQuestionEdditing});
    this.saveWebsite();
    this.scrollToSection("questions-section");
    // this.showingQuestionEditForm = false;
    if (this.fromBuilder) {
      this.fromBuilder = false;
      this.closeEditingQuestionForm();
    }
    this.isEditingQuestion = false;
  }

  updateQuestion() {
    this._analyticsService.trackEvent('Website Update Question', {question: this.currentQuestionEdditing});

    this.saveWebsite();

    this.scrollToSection("questions-section");
    if (this.fromBuilder) {
      this.fromBuilder = false;
      this.showingQuestionEditForm = false;
      this.closeEditingQuestionForm();
    }
    this.isEditingQuestion = false;
  }



  handleAddressChange(location: any) {
    this.website.welcome.eventLocation = null;
    // const countryString: string = location.adr_address.split('<span class="country-name">')[1];
    // const country = countryString.replace('</span>', '');
    if (location && !location.formatted_address && location.name) {
      this.website.welcome.eventLocation = location.name;
    } else {
      this.website.welcome.eventLocation = location.formatted_address;
    }
    // if (location.name !== country) {
    //   this.website.welcome.eventLocation = location.name + ', ' + country;
    // }    

    this.website = { ...this.website };
    this.websiteChange.emit(this.website);

  }

  roles: string[] = ['Role 1', 'Role 2', 'Role 3', 'Role 4'];
  filteredRoles: string[] = [];


  filterRoles(value: string) {
    this.filteredRoles = this.roles.filter(role => role.toLowerCase().includes(value.toLowerCase()));
  }
  setColorVibe(vibe: any) {
    this._analyticsService.trackEvent('Website Set Color Vibe', {vibe: vibe});
    this.website.colors.accent = vibe.accent;
    this.website.colors.dark = vibe.dark;
    this.website.colors.darkAccent = vibe.darkAccent;
    this.website.colors.light = vibe.light;
    this.website.colors.lightAccent = vibe.lightAccent;

    if (this.website.style == 'minimal') {
      this.setToMinimalColours();
    }
    this.initColourTexts();

    this.debounceFasterSave();
  }

  resetFilter() {
    this.filteredRoles = [];
  }

  showQuestionEditForm() {
    this._analyticsService.trackEvent('Website Show Question Edit Form', {});
    this.showingQuestionEditForm = true;
    this.isEditingQuestion = false;
    this.currentQuestionEdditing = {
      title: '',
      text: '',
      textTranslation: '',
      titleTranslation: ''

    }
    this.scrollToSection("questions-section");
  }


  selectRole(role: string) {
    this.currentPartyMemberEdditing.role = role;
    this.resetFilter();
  }
  initScheduleList() {
    if ((!this.website || Object.keys(this.website).length === 0)|| !this.website.schedule || !this.website.schedule.scheduleItems) {
      return;
    }
    this. groupedScheduleItems = this.websiteStateStore.initScheduleList(this.website);
  }
  checkIfViewingPreviewForFirstTime() {
    if (this.website && this.website.hasViewedPreview) {
      return;
    }
    else {
      this.website.hasViewedPreview = true;
      this.websiteStateStore.updateWebsite(this.website);
    }
  }
  openPreview() {
    this._analyticsService.trackEvent('Website Open Preview', {});
    this.checkIfViewingPreviewForFirstTime();
   this.updateWebsiteModal();
    if (this.cdr) {
      this.cdr.detectChanges();
    }
    this._router.navigateByUrl('/' + this.registry.registryName + "?preview=1");
  }

  linkHitchdRegistry() {
    if (!this.website.registry) {
      this.website.registry = {
        registryItems: [],
        isEnabled: true,
        sectionNameTranslation: '',
        isLinkedtoHitchd: false,
        sectionName: 'Registry',
        leadInText: '',
        leadInTextTranslation: '',
        buttonText: 'Honeymoon Registry',
        buttonTextTranslation: 'Honeymoon Registry'

      }
    }
    this.goToSection('registry-section');
    this.website.registry.isLinkedtoHitchd = true;
    this.websiteStateStore.updateWebsite(this.website);
    if (this.cdr) {
      this.cdr.detectChanges();
    }
  }

  // onDragOver(event: DragEvent) {
  //   event.preventDefault();
  //   this.dropzone.nativeElement.style.background = '#e8e8e8';
  // }

  // onDragLeave(event: DragEvent) {
  //   this.dropzone.nativeElement.style.background = '';
  // }

  // onDrop(event: DragEvent) {
  //   event.preventDefault();
  //   this.dropzone.nativeElement.style.background = '';
  //   const files = event.dataTransfer.files;
  //   this.filesDropped.emit(files);
  // }

  closeSettingsModal() {
    this._analyticsService.trackEvent('Website Close Settings Modal', {name:this.currentSectionInEditMode});
    this.showSettings = false;
    if (this.currentSectionInEditMode === 'story') {
      this.website.story.sectionName = this.previousSectionNameState;
      this.website.story.isEnabled = this.previousVisibilitySettingState;
    }
    else if (this.currentSectionInEditMode === 'schedule') {
      this.website.schedule.sectionName = this.previousSectionNameState;
      this.website.schedule.isEnabled = this.previousVisibilitySettingState;
    }

    else if (this.currentSectionInEditMode === 'weddingParty') {
      this.website.weddingParty.sectionName = this.previousSectionNameState;
      this.website.weddingParty.isEnabled = this.previousVisibilitySettingState;
    }
    else if (this.currentSectionInEditMode === 'travel') {
      this.website.travel.sectionName = this.previousSectionNameState;
      this.website.travel.isEnabled = this.previousVisibilitySettingState;
    }
    else if (this.currentSectionInEditMode === 'questions') {
      this.website.questions.sectionName = this.previousSectionNameState;
      this.website.questions.isEnabled = this.previousVisibilitySettingState;
    }
    else if (this.currentSectionInEditMode === 'registry') {
      this.website.registry.sectionName = this.previousSectionNameState;
      this.website.registry.isEnabled = this.previousVisibilitySettingState;
    }
    else if (this.currentSectionInEditMode === 'announcement') {
      // this.website.announcement.sectionName = this.previousSectionNameState;
      this.website.announcement.isEnabled = this.previousVisibilitySettingState;
    }
    else if (this.currentSectionInEditMode.toLocaleLowerCase() == 'rsvp') {
      this.website.rsvp.sectionName = this.previousSectionNameState;
      this.website.rsvp.isEnabled = this.previousVisibilitySettingState;
    }

  }


  openPopup(popupType) {

    this._analyticsService.trackEvent('Website Open Popup', {popupType: popupType});
    this.registryService.emitGenricPopup(popupType);
  }

  toggleDropDownLayout(event: Event) {
    event.stopImmediatePropagation();
    if (this.showDropDownStyle) {
      this.showDropDownStyle = false;
    }
    this.showDropDownLayout = !this.showDropDownLayout;
  }

  toggleDropDownStyle(event: Event) {
    event.stopImmediatePropagation();
    if (this.showDropDownLayout) {
      this.showDropDownLayout = false;
    }
    this.showDropDownStyle = !this.showDropDownStyle;
  }
  enableWeddingWebsite() {
    this.settings.weddingWebsiteEnabled = true;

    if (this.settings.weddingWebsiteEnabled && ((!this.website || Object.keys(this.website).length === 0) || this.website.userId != this.settings.userId)) {
      this.websiteStateStore.initWebsite(this.settings.userId, this.registry, null, false, true);


    }
    this.saveSettings()

  }

  openSettingsModal() {
    this._analyticsService.trackEvent('Website Open Settings Modal', {name:this.currentSectionInEditMode});
    this.showSettings = true;
    this.previousSectionNameState = "";
    this.previousVisibilitySettingState = false;
    if (this.currentSectionInEditMode === 'story') {
      this.previousSectionNameState = this.website.story.sectionName;
      this.previousVisibilitySettingState = this.website.story.isEnabled;
    }
    else if (this.currentSectionInEditMode === 'schedule') {
      this.previousSectionNameState = this.website.schedule.sectionName;
      this.previousVisibilitySettingState = this.website.schedule.isEnabled;
    }

    else if (this.currentSectionInEditMode === 'announcement') {
      // this.previousSectionNameState = this.website.announcement.sectionName;
      this.previousVisibilitySettingState = this.website.announcement.isEnabled;
    }
    else if (this.currentSectionInEditMode === 'weddingParty') {
      this.previousSectionNameState = this.website.weddingParty.sectionName;
      this.previousVisibilitySettingState = this.website.weddingParty.isEnabled;
    }
    else if (this.currentSectionInEditMode === 'travel') {
      this.previousSectionNameState = this.website.travel.sectionName;
      this.previousVisibilitySettingState = this.website.travel.isEnabled;
    }
    else if (this.currentSectionInEditMode === 'questions') {
      this.previousSectionNameState = this.website.questions.sectionName;
      this.previousVisibilitySettingState = this.website.questions.isEnabled;
    }
    else if (this.currentSectionInEditMode === 'registry') {
      this.previousSectionNameState = this.website.registry.sectionName;
      this.previousVisibilitySettingState = this.website.registry.isEnabled;
    }
    else if (this.currentSectionInEditMode.toLocaleLowerCase() == 'rsvp') {
      this.previousSectionNameState = this.website.rsvp.sectionName;
      this.previousVisibilitySettingState = this.website.registry.isEnabled;
    }


    //find the div with section-detail class and scroll to the top for it 

    const element = document.querySelector('.section-detail');
    if (element) {
      element.scrollTo(0, 0);
    }


  }

  scrollToSection(sectionModalName: string) {
    const element = document.getElementById(sectionModalName);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  showRegistryItemForm() {
    this.showingQuestionEditForm = true;
    this.currentRegistryItemEditing = {
      name: '',
      url: '',
      logo: '',
    }
    this.isEditingRegistryItem = false;
    this.goToSection('registry-section');
  }
  closeQuestionSection() {
    this.showingQuestionEditForm = false;
    this.currentQuestionEdditing = null;
    this.isEditingQuestion = false;

  }

  closeEditingQuestionForm() {

    this.currentQuestionEdditing = null;
    this.isEditingQuestion = false;

    if (this.fromBuilder) {
      this.fromBuilder = false;
      this.showingQuestionEditForm = false;
    }

  }
  addNewRegistryItem() {
    if (!this.website.registry) {
      this.website.registry = {
        registryItems: [],
        isEnabled: true,
        buttonText: 'Honeymoon Registry',
        buttonTextTranslation: 'Honeymoon Registry',
        sectionNameTranslation: '',
        isLinkedtoHitchd: false,
        sectionName: 'Registry',

        leadInText: '',
        leadInTextTranslation: '',
      }
    } else if (!this.website.registry.registryItems) {
      this.website.registry.registryItems = [];
    }

    this.website.registry.registryItems.push(this.currentRegistryItemEditing);
    this.saveWebsite();
    this.goToSection('registry-section');
    this.showingQuestionEditForm = false;
  }
  updateRegistryItem() {
    this.saveWebsite();
    this.showSettings = false;
    this.goToSection('registry-section');
    this.currentRegistryItemEditing = null;
    this.showingQuestionEditForm = false;
  }

  closeRegistryItemFormSection() {
    this.showSettings = false;
    this.currentRegistryItemEditing = null;
    this.isEditingRegistryItem = false;
    this.goToSection('registry-section');
    this.showingQuestionEditForm = false;

  }

  translateLanguage() {
    if (this.viewingSecondLanguage) {
      this.appWebsite.reverseTranslation(this.website)
    }
    else {
      this.appWebsite.changeLang()
    }
    this.viewingSecondLanguage = !this.viewingSecondLanguage;

  }

  toggleLanguage(enabled: boolean) {
    this._analyticsService.trackEvent('Website Toggle Language', {enabled: enabled});
    this.editingSecondaryLanguage = enabled;
    this.websiteStateStore.emitTranlation(enabled);
    this.appWebsite.changeLang();



  }

  editRegistryItem(registryItem: RegistryItem) {
    this.showSettings = false;
    this.currentRegistryItemEditing = registryItem;
    this.showingQuestionEditForm = true;
    this.isEditingRegistryItem = true;
  }
  endDatePicked() {
    this.endDateError = false;


    if (this.currentScheduleEventEdditing.startDate && this.currentScheduleEventEdditing.endDate) {
      const startDateTime = new Date(this.currentScheduleEventEdditing.startDate);
      const endDateTime = new Date(this.currentScheduleEventEdditing.endDate);

      if (this.currentScheduleEventEdditing.startTime) {
        const startTimeParts = this.currentScheduleEventEdditing.startTime.match(/(\d+):(\d+) (AM|PM)/);
        let startHours = parseInt(startTimeParts[1]);
        const startMinutes = parseInt(startTimeParts[2]);
        const startPeriod = startTimeParts[3];

        if (startPeriod === 'PM' && startHours !== 12) {
          startHours += 12;
        } else if (startPeriod === 'AM' && startHours === 12) {
          startHours = 0;
        }

        startDateTime.setHours(startHours);
        startDateTime.setMinutes(startMinutes);
      }

      if (this.currentScheduleEventEdditing.endTime) {
        const endTimeParts = this.currentScheduleEventEdditing.endTime.match(/(\d+):(\d+) (AM|PM)/);
        let endHours = parseInt(endTimeParts[1]);
        const endMinutes = parseInt(endTimeParts[2]);
        const endPeriod = endTimeParts[3];

        if (endPeriod === 'PM' && endHours !== 12) {
          endHours += 12;
        } else if (endPeriod === 'AM' && endHours === 12) {
          endHours = 0;
        }

        endDateTime.setHours(endHours);
        endDateTime.setMinutes(endMinutes);
      }

      if (startDateTime && endDateTime) {
        if (startDateTime > endDateTime) {
          this.endDateError = true;
        } else if (startDateTime.getTime() === endDateTime.getTime() && this.currentScheduleEventEdditing.startTime && this.currentScheduleEventEdditing.endTime) {
          const startTimeParts = this.currentScheduleEventEdditing.startTime.match(/(\d+):(\d+) (AM|PM)/);
          const endTimeParts = this.currentScheduleEventEdditing.endTime.match(/(\d+):(\d+) (AM|PM)/);

          let startHours = parseInt(startTimeParts[1]);
          const startMinutes = parseInt(startTimeParts[2]);
          const startPeriod = startTimeParts[3];

          let endHours = parseInt(endTimeParts[1]);
          const endMinutes = parseInt(endTimeParts[2]);
          const endPeriod = endTimeParts[3];

          if (startPeriod === 'PM' && startHours !== 12) {
            startHours += 12;
          } else if (startPeriod === 'AM' && startHours === 12) {
            startHours = 0;
          }

          if (endPeriod === 'PM' && endHours !== 12) {
            endHours += 12;
          } else if (endPeriod === 'AM' && endHours === 12) {
            endHours = 0;
          }

          if (startHours > endHours || (startHours === endHours && startMinutes >= endMinutes)) {
            this.endDateError = true;
          }
        }
      }
    }

    this.currentScheduleEventEdditing.startDateUtc = this.websiteStateStore.preserveDateOnly(this.currentScheduleEventEdditing.startDate);
    if (this.currentScheduleEventEdditing.endDate){
      this.currentScheduleEventEdditing.endDateUtc = this.websiteStateStore.preserveDateOnly(this.currentScheduleEventEdditing.endDate);
    } else {
      this.currentScheduleEventEdditing.endDateUtc = null;
    }
  }
  getTimeValuesFromTimeString(timeString: string) {

    const timeParts = timeString.match(/(\d+):(\d+)/);
    let hours = parseInt(timeParts[1]);
    const minutes = parseInt(timeParts[2]);

    let period = 'AM';
    if (hours >= 12) {
      period = 'PM';
      if (hours > 12) {
        hours -= 12;
      }
    } else if (hours === 0) {
      hours = 12;
    }

    return {
      hours,
      minutes,
      period
    }

  }

  commonQuestion(title: string, text: string) {

    this.showingQuestionEditForm = true;
    this.currentQuestionEdditing = {
      title: title,
      textTranslation: '',
      titleTranslation: '',
      text: text
    }
    this.isEditingQuestion = false;
   
    this.addNewQuestion();
  }
  setFirstAndLastSections() {
    this.firstSection = this.website.sectionOrder[0];
    this.lastSection = this.website.sectionOrder[this.website.sectionOrder.length - 1];
  }

  resizeWebsiteContainer(width: any, height: any) {
    this.websiteContainerWidth = width;
    this.websiteContainerHeight = height;
  }

  goToSection(id: string) {

    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }



  moveSectionUp(event: Event, sectionName: string) {
    //move section up the sectionOrder array
    
    event.stopImmediatePropagation();
    let index = this.website.sectionOrder.indexOf(sectionName);
    if (index > 0) {
      let temp = this.website.sectionOrder[index - 1];
      this.website.sectionOrder[index - 1] = sectionName;
      this.website.sectionOrder[index] = temp;

    }
    this.website = { ...this.website };
    this.saveWebsite()

    this.setFirstAndLastSections()

  }

  getStartDateFromEventDate(): Date {
    if (this.website.welcome.eventDate) {
      return new Date(this.website.welcome.eventDate);
    } else if (this.website.weddingEvents && this.website.weddingEvents.length > 0) {
      return new Date(this.website.weddingEvents[0].startDate);
    }
  }

  createNewSectionEvent() {
    

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.isEditingSchedule = false;
    this.showEndTime = false;
    this.showAddNewScheduleEvent = true;

    this.currentScheduleEventEdditing = {
      eventName: '',
      startDate: this.getStartDateFromEventDate(),
      startDateUtc: this.websiteStateStore.preserveDateOnly(this.getStartDateFromEventDate()),     
      startTime: '12:00 PM',
      venue: '',
      address: '',
      attire: '',
      description: '',
      attireTranslation: '',
      descriptionTranslation: '',
      eventNameTranslation: '',
      endDate: null,
      endDateUtc: null,
      endTime: null,
      addressTranslation: '',
      venueTranslation: '',


    }
    this.goToSection('schedule-section');

    this.currentScheduleEventEdditing.endDate = null;

  }

  addNewQuestionShowForm() {
    this._analyticsService.trackEvent('Website Add New Question', {});
    this.isEditingQuestion = true;
    this.currentQuestionEdditing = {
      title: '',
      text: '',
      textTranslation: '',
      titleTranslation: ''
    }
    this.fromBuilder = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.currentEditingQuestionIndex = null;
  }
  editQuestion(question: Question, index: number, fromBuilder = false) {
    this._analyticsService.trackEvent('Website Edit Question', {question: question, index: index, fromBuilder: fromBuilder});
    this.showingQuestionEditForm = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.currentQuestionEdditing = question;
    this.goToSection('questions-section');
    this.isEditingQuestion = true;
    this.fromBuilder = fromBuilder;
    this.currentEditingQuestionIndex = index;
  }
  deleteQuestion(question: Question, event: Event) {
    this._analyticsService.trackEvent('Website Delete Question', {question: question, event: event});
    this.goToSection('questions-section');
    this.website.questions.questions = this.website.questions.questions.filter(x => x !== question);
    this.saveWebsite();
  }
  deleteRegistryItem(registryItem: RegistryItem) {
    this.website.registry.registryItems = this.website.registry.registryItems.filter(x => x != registryItem);
    this.goToSection('registry-section');
    this.saveWebsite();

  }
  getTimeString(date: Date) {

    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  }

  initEndTime() {
    this.currentScheduleEventEdditing.endDate = new Date(this.currentScheduleEventEdditing.startDate);
    if (this.currentScheduleEventEdditing.startTime) {
      // add 1 hour more to the start time and set that as the end time, it should acount for 11:00 PM to 12:00 AM
      let startTime = this.getTimeValuesFromTimeString(this.currentScheduleEventEdditing.startTime);
      let endTime = new Date(this.currentScheduleEventEdditing.startDate);
      endTime.setHours(startTime.hours + 1, startTime.minutes);
      this.currentScheduleEventEdditing.endTime = this.getTimeString(endTime);

    } else {
      this.currentScheduleEventEdditing.endTime = '12:00 PM';
    }

    this.showEndTime = true;
  }
  closeNewSectionEvent() {
    this.showAddNewScheduleEvent = false;
    this.currentScheduleEventEdditing = null;
  }

  addNewScheduleEvent() {
    this._analyticsService.trackEvent('Website Add New Schedule Event', this.currentScheduleEventEdditing);
    if (!this.website.schedule || !this.website.schedule.scheduleItems) {

      this.website.schedule = {
        sectionName: 'Schedule',
        scheduleItems: [],
        sectionNameTranslation: '',
        isEnabled: true,
        updated: false

      };
    }
    this.website.schedule.scheduleItems.push(this.currentScheduleEventEdditing);
    this.saveWebsite();
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.showAddNewScheduleEvent = false;
    this.initScheduleList();
    this.scrollToSection('schedule-section');
    this.setUpdatedOnceTouched('schedule.sectionName');
    this.saveWebsite();
    this.registryService.emitGenericToastMsg("Schedule Moment Added");
  }
  setTravelInfoType(type: string) {
    this._analyticsService.trackEvent('Website Set Travel Info Type', {type: type});
    this.currentTravelInfoEdditing.travelType = type;

    if (type === 'flight') {
      this.currentTravelInfoEdditing.title = 'Flight';
    }

  }
  updateSectionEvent() {
    
    this._analyticsService.trackEvent('Website Update Section Event', this.currentScheduleEventEdditing);

    if (this.currentScheduleItemIndex>-1){
      this.website.schedule.scheduleItems[this.currentScheduleItemIndex] = this.currentScheduleEventEdditing;
    }
    this.setUpdatedOnceTouched('schedule.sectionName');
    this.saveWebsite();
    this.showAddNewScheduleEvent = false;
    this.isEditingSchedule = false;
    this.initScheduleList();
  }
  deleteScheduleItem(scheduleItem: ScheduleItem) {
    this._analyticsService.trackEvent('Website Delete Schedule Item', {scheduleItem: scheduleItem});
    let index = this.website.schedule.scheduleItems.findIndex(x => x.eventName === scheduleItem.eventName
      && x.startDate === scheduleItem.startDate
      && x.startTime === scheduleItem.startTime
      && x.endDate === scheduleItem.endDate
      && x.endTime === scheduleItem.endTime
    );
    if (index > -1) {
      this.website.schedule.scheduleItems.splice(index, 1);
    }
    
    this.setUpdatedOnceTouched('schedule.sectionName');
    this.saveWebsite();
    this.initScheduleList();
  }

  switchBackToEnglish() {

    if (this.editingSecondaryLanguage) {
      this.toggleLanguage(false);
    }
  }

  showTravelInfoEditForm() {  
    this._analyticsService.trackEvent('Website Show Travel Info Edit Form', {});
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.switchBackToEnglish();
    this.showingPartyPersonForm = true;
    this.isEditingTravelInfo = false;
    this.currentTravelInfoEdditing = {
      title: '',
      notesTranslation: '',
      titletranslation: '',
      travelType: '',
      travelLinks: [],

      notes: '',
      url: '',
      address: '',
      phone: '',
      flightNumber: '',
      discountCode: '',
    }

  }

  showPartyPersonEditForm() {
    this._analyticsService.trackEvent('Website Show Party Person Edit Form', {});
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.showingPartyPersonForm = true;
    this.isEditingPerson = false;
    this.currentPartyMemberEdditing = {
      firstName: '',
      lastName: '',
      role: '',
      imageUrl: '',
      roleTranslation: '',
      storyTranslation: '',
      story: '',
      email: '',
      phone: ''
    }
    this.scrollToSection("weddingParty-section");
  }
  closeNewWeddingPartySection() {
    this.showingPartyPersonForm = false;
    this.currentPartyMemberEdditing = null;
    this.isEditingPerson = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.scrollToSection("weddingParty-section");
  }
  closeNewTravelInfoSection() {
    this.showingPartyPersonForm = false;
    this.currentPartyMemberEdditing = null;
    this.isEditingPerson = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.scrollToSection("travel-section");
  }
  deleteParterMember(partyMember: PartyMember) {
    this._analyticsService.trackEvent('Website Delete Party Member', {partyMember: partyMember});
    this.website.weddingParty.partyMembers = this.website.weddingParty.partyMembers.filter(x => x !== partyMember);
    this.saveWebsite();


  }
  editPartyMember(partyMember: PartyMember) {
    this._analyticsService.trackEvent('Website Edit Party Member', {partyMember: partyMember});
    this.showingPartyPersonForm = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.isEditingPerson = true;
    this.currentPartyMemberEdditing = partyMember;
    this.scrollToSection("weddingParty-section");


  }
  addNewPartyPerson() {
    this._analyticsService.trackEvent('Website Add New Party Member', this.currentPartyMemberEdditing);
    if (!this.website.weddingParty || !this.website.weddingParty.partyMembers) {

      this.website.weddingParty = {
        introTranslation: '',
        sectionName: 'Wedding Party',
        sectionNameTranslation: '',
        partyMembers: [],
        isEnabled: true,
        intro: '',

      };
    }
    this.website.weddingParty.partyMembers.push(this.currentPartyMemberEdditing);
    this.saveWebsite();
    this.registryService.emitGenericToastMsg("Party Member Added");
    this.scrollToSection("weddingParty-section");
    this.showingPartyPersonForm = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

  }

  deleteTravelInfo(travelInfo: TravelInfo) {
    this._analyticsService.trackEvent('Website Delete Travel Info', {travelInfo: travelInfo});
    this.website.travel.travelInfo = this.website.travel.travelInfo.filter(x => x !== travelInfo);

    this.registryService.emitGenericToastMsg("Travel Guide Deleted");
    this.scrollToSection("travel-section");
    this.saveWebsite();
  }
  editTravelInfo(travelInfo: TravelInfo) {
    this._analyticsService.trackEvent('Website Edit Travel Info', {travelInfo: travelInfo});
    this.showingPartyPersonForm = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.isEditingTravelInfo = true;
    this.currentTravelInfoEdditing = travelInfo;
    this.scrollToSection("travel-section");
  }
  addNewTravelInfo() {
    this._analyticsService.trackEvent('Website Add New Travel Info', this.currentTravelInfoEdditing);
    if (!this.website.travel || !this.website.travel.travelInfo) {

      this.website.travel = {
        travelInfo: [],
        sectionNameTranslation: '',
        sectionName: 'Travel',
        isEnabled: true,

      };
    }
    this.website.travel.travelInfo.push(this.currentTravelInfoEdditing);
    this.saveWebsite();
    this.scrollToSection("travel-section");
    this.showingPartyPersonForm = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.registryService.emitGenericToastMsg("Travel Info Added");

  }

  saveAndClose() {
    this.enableSave = false;
    this.showSettings = false;
    this.saveWebsite();
  }
  updateTravelInfo() {
    this._analyticsService.trackEvent('Website Update Travel Info', this.currentTravelInfoEdditing);
    this.saveWebsite();
    this.showingPartyPersonForm = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

    this.scrollToSection("travel-section");
    this.isEditingTravelInfo = false;
  }
  updatePartyPerson() {
    this._analyticsService.trackEvent('Website Update Party Person', this.currentPartyMemberEdditing);
    this.saveWebsite();
    this.showingPartyPersonForm = false;
    this.isEditingPerson = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }

  editScheduleItem(scheduleItem: ScheduleItem) {
    this._analyticsService.trackEvent('Website Edit Schedule Item', {scheduleItem: scheduleItem});
    this.showAddNewScheduleEvent = true;
    this.isEditingSchedule = true;
    if (!scheduleItem.endDate) {
      this.showEndTime = false;
    } else {
      this.showEndTime = true;
    }
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.goToSection('schedule-section');
    this.currentScheduleEventEdditing = scheduleItem;
    
    this.currentScheduleItemIndex = this.website.schedule.scheduleItems.findIndex(x => x.eventName === scheduleItem.eventName);
    this.initScheduleList();


  }

  moveSectionDown(event: Event, sectionName: string) {
    event.stopImmediatePropagation();
    let index = this.website.sectionOrder.indexOf(sectionName);
    if (index < this.website.sectionOrder.length - 1) {
      let temp = this.website.sectionOrder[index + 1];
      this.website.sectionOrder[index + 1] = sectionName;
      this.website.sectionOrder[index] = temp;


    }
    this.website = { ...this.website };
    this.saveWebsite()
    this.setFirstAndLastSections()


  }
  saveWebsite() {
   console.trace('saveWebsite called'); // Call stack included
   this.updateWebsiteModal();
      this.websiteStateStore.updateWebsite(this.website);
  }


  scrollToTopOfSections() {

    let asideElements = document.getElementsByTagName('aside');
    if (asideElements.length > 0) {
      asideElements[0].scrollTop = 0;
    }

  }


  editSection(sectionName: string) {
    this._analyticsService.trackEvent('Website Edit Section', {sectionName: sectionName});
    localStorage.setItem('sectionName', sectionName);
    this.currentSectionInEditMode = sectionName;
    this.mode = 'content';
    this.editingSection = true;
    this.showSettings = false;
    this.showFontSelectionModal = false;
    this.showChangeColourPanel = false;

    // Check if there are any 'aside' elements before trying to access the first one
    let asideElements = document.getElementsByTagName('aside');
    if (asideElements.length > 0) {
      asideElements[0].scrollTop = 0;
    }

    // Check if the 'goToSection' method exists before trying to call it
    if (this.goToSection) {
      this.goToSection(sectionName + '-section');
    }
  }

  closeSettings() {

  }
  goBackToSections() {

    this.editingSection = false;
    this.currentSectionInEditMode = null;
    this.mode = 'content';
    this.showSettings = false;

  }





  editAnnouncementSection() {
        this._analyticsService.trackEvent('Website Edit Section', {sectionName: 'Announcement'});
    this.editingAnnouncement = true;
    this.editingSection = true;
    this.goToSection('announcement-section');
  }



  editWelcomeSection() {
    this._analyticsService.trackEvent('Website Edit Section', {sectionName: 'Welcome'});
    this.editingWelcome = true;
    this.editingSection = true;
    this.goToSection('welcome-section');
  }
  editStorySection() {
    this._analyticsService.trackEvent('Website Edit Section', {sectionName: 'Story'});
    this.editingStory = true;
    this.editingSection = true;
    this.goToSection('story-section');
  }


  isLightColor(r, g, b) {
    // Calculate the brightness of the color
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    // If the brightness is over 128, it's a light color
    return brightness > 128;
  }
  hexToRgb(hex: string): { r: number, g: number, b: number } | null {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }


  initColourTexts() {

    this.light_isLight = this.setColour(this.website.colors.light, null, true);
    this.dark_isLight = this.setColour(this.website.colors.dark, null, true);
    this.lightAccent_isLight = this.setColour(this.website.colors.lightAccent, null, true);
    this.darkAccent_isLight = this.setColour(this.website.colors.darkAccent, null, true);
    this.accent_isLight = this.setColour(this.website.colors.accent, null, true);


  }

  deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
      return true;
    }

    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
      return false;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  setColour(colour: string, isLight: string = null, doNotSave = false): boolean {
    this.showResetColour = true;
    let isList = false;
    if (colour.startsWith('#')) {
      let rgb = this.hexToRgb(colour);
      isList = this.isLightColor(rgb.r, rgb.g, rgb.b);
      if (isLight) {
        this[isLight] = isList;
      }

    }
    ;
    if (doNotSave == false) {

      this.debounceSave();
    }
    return isList;
  }
  rsvpEndDatePicked(){
    if (this.website.welcome.rsvpDeadline){     
      this.website.welcome.rsvpDeadlineDateUtc = this.websiteStateStore.preserveDateOnly(this.website.welcome.rsvpDeadline);
      this.websiteStateStore.updateWebsite(this.website);
    }
  }
  eventDatePicked(){
    
    if (this.website.welcome.eventDate){     
      this.website.welcome.eventDateUtc = this.websiteStateStore.preserveDateOnly(this.website.welcome.eventDate);
      this.websiteStateStore.updateWebsite(this.website);
    }
  }
  removeEventEndDate(){
    this.website.welcome.eventEndDate = null;
    this.website.welcome.eventEndDateUtc = null;
    this.showEventEndDate = false;
    this.websiteStateStore.updateWebsite(this.website);
  }
  addEventEndDate(){
    this.showEventEndDate = true;
    let endDate = new Date();
    if (this.website.welcome.eventDate){
      endDate = new Date(this.website.welcome.eventDate);
    }
    //add 1 day to the end date
    endDate.setDate(endDate.getDate() + 1);
    this.website.welcome.eventEndDate = endDate;
    this.websiteStateStore.updateWebsite(this.website);
  }
  eventEndDatePicked(){
    if (this.website.welcome.eventEndDate){     
      this.website.welcome.eventEndDateUtc = this.websiteStateStore.preserveDateOnly(this.website.welcome.eventEndDate);
      this.websiteStateStore.updateWebsite(this.website);
    }
    this.showEventEndDate = false;
  }


  debounceSave(scrollToElement: string = null) {
    this.setUpdatedOnceTouched(scrollToElement);
    if (scrollToElement) {
      this.scrollToSection(scrollToElement);
    }
  this.updateWebsiteModal();
    this.saveWebsiteSubject.next();
  }
  private setUpdatedOnceTouched(scrollToElement: string) {
    if (!scrollToElement) {
      return;
    }
    if (scrollToElement.startsWith('welcome.')) {
      this.website.welcome.updated = true;
    }
    if (scrollToElement.startsWith('story.')) {
      this.website.story.updated = true;
    }
    if (scrollToElement.startsWith('schedule.')) {
      this.website.schedule.updated = true;
    }
  }

  debounceFasterSave() {
   this.updateWebsiteModal();
    if (this.cdr) {
      this.cdr.detectChanges();
    }
    this.saveWebsiteSubject.next();
  }

  setupRegistry() {
    this._analyticsService.trackEvent('Website - Setup Registry clicked', {});
    this._router.navigate(['/registry']);
  }

}


// WEBPACK FOOTER //
// ./src/app/website-builder/website-builder.component.ts